import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export default class IssueCountDefinition {
  static getDefault = () =>
    new IssueCountDefinition({
      issueCountType: "ExHedges",
      summary: SummaryType.ABSOLUTE,
    });

  #issueCountType;
  #summary;

  constructor({ issueCountType, summary }) {
    this.#issueCountType = issueCountType;
    this.#summary = summary;
  }
  get issueCountType() {
    return this.#issueCountType;
  }
  get summary() {
    return this.#summary;
  }

  setIssueCountType = (value) =>
    new IssueCountDefinition({
      ...this.copy(),
      issueCountType: value,
    });
  setSummary = (value) =>
    new IssueCountDefinition({
      ...this.copy(),
      summary: value,
    });

  get complete() {
    return true;
  }

  get key() {
    return `${scope} - ${this.issueCountType}, ${this.summary}`;
  }

  copy = () => {
    return {
      issueCountType: this.issueCountType,
      summary: this.summary,
    };
  };
}
